// @ts-nocheck
/* eslint-disable */
export const boldArrowCircleDownIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="6 6 20 20"><path fill="currentColor" d="m19.737 15.745.006-.006a1.13 1.13 0 0 0-.006-1.584 1.13 1.13 0 0 0-1.59 0L16 16.3l-2.147-2.146a1.13 1.13 0 0 0-1.59 0 1.13 1.13 0 0 0 0 1.59l2.942 2.942c.223.224.511.33.795.33s.571-.106.795-.33zM8.167 16c0-4.315 3.517-7.833 7.833-7.833 4.315 0 7.833 3.518 7.833 7.833S20.315 23.833 16 23.833 8.166 20.316 8.166 16"/></svg>`,
    name: 'bold-arrow-circle-down' as const
};